import { supabase } from './supabase'

/* The session user id, for scoping reads and stamping writes.
 *
 * This is identity, not authorization — RLS still decides what the id is allowed
 * to touch. Reading it here rather than accepting it as a function argument makes
 * it impossible for a caller to pass an id that disagrees with the JWT and
 * collect a confusing policy denial instead of a clear one.
 *
 * getSession reads local storage; it is not a network round trip. */
export async function currentUserId() {
  const { data, error } = await supabase.auth.getSession()
  if (error) throw error
  const userId = data.session?.user.id
  if (!userId) throw new Error('Called without a session; RequireAuth should have prevented this')
  return userId
}
